var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldRenderIframe)?_c('iframe',{attrs:{"id":"chat-iframe","loading":"lazy","src":"/chattigo.html"},on:{"load":_vm.handleChatWidget,"error":_vm.handleIframeError}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }